<script setup lang="ts">
import { Button } from 'pejer/src/components/ui/button'
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from 'pejer/src/components/ui/dialog'
import { Input } from 'pejer/src/components/ui/input'
import { Label } from 'pejer/src/components/ui/label'
import { computed, ref } from 'vue'

const props = defineProps<{
  word?: string
  title?: string
  description?: string
}>()

const emits = defineEmits<{
  (e: 'confirmed'): void
}>()

const inputtedConfirmationWord = ref<string>('')
const confirmationWord = ref<string>(props.word || 'Bekreft')

const isCorrectlyConfirmed = computed(
  () =>
    (inputtedConfirmationWord.value.toLowerCase() as any).replaceAll('"', '') ===
    confirmationWord.value.toLowerCase()
)

function checkConfirmation() {
  if (isCorrectlyConfirmed.value) emits('confirmed')
}
</script>

<template>
  <Dialog>
    <DialogTrigger @click.prevent.stop as-child>
      <slot />
    </DialogTrigger>
    <DialogContent
      class="sm:max-w-[425px] z-[10000000]"
      @open-auto-focus="inputtedConfirmationWord = ''"
    >
      <DialogHeader>
        <DialogTitle>
          {{ props.title || 'Er du sikker?' }}
        </DialogTitle>
        <DialogDescription>
          <slot name="description">
            {{ props.description || 'Skriv inn ordet under for å bekrefte.' }}
          </slot>
          <div class="flex items-center mt-3 flex-wrap">
            <span class="text-nowrap">Skriv inn bekreftelsesordet</span>
            <div class="bg-gray-100 py-1 px-2 rounded-md w-fit mx-2 font-bold">
              "<span class="text-red-500">{{ confirmationWord }}</span
              >"
            </div>
            nedenfor
          </div>
        </DialogDescription>
      </DialogHeader>
      <div class="flex flex-col gap-1">
        <Label for="confirmationWord"> Bekreftelsesord </Label>
        <Input
          id="confirmationWord"
          v-model="inputtedConfirmationWord"
          :placeholder="confirmationWord"
        />
      </div>
      <DialogFooter>
        <DialogClose as-child>
          <Button type="button" variant="secondary"> Avbryt </Button>
        </DialogClose>
        <DialogClose as-child>
          <Button :disabled="!isCorrectlyConfirmed" @click="checkConfirmation"> Bekreft </Button>
        </DialogClose>
      </DialogFooter>
    </DialogContent>
  </Dialog>
</template>
